import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://3.94.206.170:3333',
  baseURL: 'https://api-status.2bebot.com.br/',
  // baseURL: 'https://trp-api.2bebot.com.br/',
});

export default api;
